import { Text, View, useThemeProvider } from "@towersystems/roam-common-native";
import {
  NavigationState,
  SceneRendererProps,
  TabBar,
} from "react-native-tab-view";
import { Spacings } from "react-native-ui-lib";

export type StockCountTabBarProps = SceneRendererProps & {
  navigationState: NavigationState<{
    key: string;
    title: string;
  }>;
};

export function StockCountTabBar(props: StockCountTabBarProps) {
  const { colors } = useThemeProvider();

  return (
    <TabBar
      {...props}
      lazy
      indicatorStyle={{
        backgroundColor: colors.primary,
        height: 3,
        bottom: 0,
      }}
      indicatorContainerStyle={{
        height: 3,
        //@ts-ignore
        inset: "auto auto -3px auto",
        bottom: 0,
      }}
      tabStyle={{
        height: 80,
      }}
      style={{
        backgroundColor: colors.surface,
        marginBottom: Spacings.s4,
        height: 80,
      }}
      renderLabel={({ route, focused }) => (
        <View
          style={{
            height: 60,
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <Text style={{ textTransform: "none" }} variant="heading1">
            {route.title}
          </Text>
        </View>
      )}
    />
  );
}
